var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fadeInUp","mode":"out-in"}},[(_vm.show)?_c('div',{staticClass:"model_container"},[_c('div',{staticClass:"main_body"},[_vm._t("modal")],2),_c('div',{staticClass:"modal_overlay",on:{"click":_vm.closeModel}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }